export const environment = {
  apiUrl: 'https://api-dev.acabjj.ch/dev',
  appUrl: 'https://dev.acabjj.ch',
  domain: 'dev.acabjj.ch',
  robotNoIndex: true
};
